import React from 'react'
import styled, { keyframes } from 'styled-components'

const Dash = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`

const AnimatedLine = styled.line<{ animationDelay: string, animationSpeed: string }>`
  animation: ${Dash} ${({ animationSpeed }) => animationSpeed} cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards;
  animation-delay: ${({ animationDelay }) => animationDelay};
`

interface CrossMarkProps extends React.SVGProps<SVGSVGElement> {
  animationDelay?: string
  animationSpeed?: string
}

function Crossmark({ animationDelay = '0.05s', animationSpeed = '0.15s', ...props }: CrossMarkProps): React.ReactElement {
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" strokeWidth={4} stroke="white" {...props}>
      <AnimatedLine
        x1="16"
        y1="16"
        x2="36"
        y2="36"
        strokeDasharray={28.28}
        strokeDashoffset={28.28}
        animationDelay={animationDelay}
        animationSpeed={animationSpeed}
      />
      <AnimatedLine
        x1="36"
        y1="16"
        x2="16"
        y2="36"
        strokeDasharray={28.28}
        strokeDashoffset={28.28}
        animationDelay={`calc(${animationDelay} + ${animationSpeed})`}
        animationSpeed={animationSpeed}
      />
    </svg>
  )
}

export default Crossmark
